<template>
  <!-- 需要实现点击穿透 -->
  <div id="email-download-box"
    class="mask"
    v-if="visible">
    <div class="download-wrap"
      :style="[isMobile ? {
        width: '100vmin',
        height: '95vmax',
        backgroundImage: imageUrl
      } : {
        width: '35%',
        height: '100%',
        backgroundImage: imageUrl
      }]"
      @click="handleDownload"></div>
  </div>
</template>

<script>
import { DEVICE_TYPE } from "@/constant";
import { handleAddPwa, postParentMsg } from "@/util/cloudgame/game-service";

export default {
  name: "EmailBox",
  data() {
    return {
      visible: true,
      isMobile: DEVICE_TYPE.isMobile,
      imageUrl: "",
    };
  },
  mounted() {
    if (document.getElementById("CloudGameContainer")) {
      document
        .getElementById("CloudGameContainer")
        .addEventListener("click", this.handleClose);
    }
  },
  methods: {
    async autoClick() {
      const TOUCH = {
        START: 1,
        END: 0,
        MOVE: 3,
      };
      const KEY = {
        CLICK_KEY: "click_key",
      };
      const ids = ["mouse"];
      const key = KEY.CLICK_KEY;
      function generateIds(key, touchType) {
        if (touchType === TOUCH.END) {
          const index = ids.indexOf(key);
          ids[index] = "";
          return index;
        }
        if (touchType === TOUCH.MOVE) {
          return ids.indexOf(key);
        }
        for (let i = 1; i < ids.length; i++) {
          if (ids[i] === "") {
            ids[i] = key;
            return i;
          }
        }
        ids.push(key);
        return ids.length - 1;
      }

      // ! 重要 对于多次连续的没有被释放的相同start事件 将后续的事件都转为move事件
      if (ids.includes(key) && touchType === TOUCH.START) {
        touchType = TOUCH.MOVE;
      }
      const identifier1 = generateIds(key, TOUCH.START);
      const identifier2 = generateIds(key, TOUCH.START);
      const identifier3 = generateIds(key, TOUCH.START);

      const pos1 = { x: 150, y: 50 };
      const pos2 = { x: 155, y: 60 };
      const pos3 = { x: 160, y: 70 };

      // console.log(ids, key, identifier);

      let touches_1 = {
        ...pos1,
        identifier: identifier1,
        force: 1,
      };
      window.cg.touchManager.sendTouchData([touches_1], TOUCH.START);
      setTimeout(() => {
        window.cg.touchManager.sendTouchData([touches_1], TOUCH.END);
      }, 100);

      let touches_2 = {
        ...pos2,
        identifier: identifier2,
        force: 1,
      };
      window.cg.touchManager.sendTouchData([touches_2], TOUCH.START);
      setTimeout(() => {
        window.cg.touchManager.sendTouchData([touches_2], TOUCH.END);
      }, 100);

      let touches_3 = {
        ...pos3,
        identifier: identifier3,
        force: 1,
      };
      window.cg.touchManager.sendTouchData([touches_3], TOUCH.START);
      setTimeout(() => {
        window.cg.touchManager.sendTouchData([touches_3], TOUCH.END);
      }, 100);

      setTimeout(() => {
        this.visible = false;
      }, 1000);
    },
    async handleClose() {
      if (document.getElementById("email-download-box")) {
        await this.autoClick();
        handleAddPwa("cancelDownlaod", this);
      }
    },
    hide() {
      this.visible = false;
    },
    handleDownload() {
      this.autoClick();
      postParentMsg("download", "email");
    },
  },
  beforeDestroy() {
    if (document.getElementById("CloudGameContainer")) {
      document
        .getElementById("CloudGameContainer")
        .removeEventListener("click", this.handleClose);
    }
  },
};
</script>

<style scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 4;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
.download-wrap {
  width: 100vmin;
  height: 100vh;
  background-size: 100% 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  object-fit: cover;
  pointer-events: auto;
}
</style>